import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";

export type SummaryFormatters = {
	/** Whole hours, grouped ("29,508"). */
	formatHours: (hours: number) => string;
	/** Whole counts, grouped like hours. */
	formatCount: (count: number) => string;
	/** A share as a percentage with two decimals ("99.86%"). */
	formatPercent: (share: number) => string;
};

/** The Summary's number formats, in the reader's language. */
export const useSummaryFormatters = (): SummaryFormatters => {
	const { i18n } = useTranslation();
	const wholeFormatter = useMemo(() => new Intl.NumberFormat(i18n.language, { maximumFractionDigits: 0 }), [i18n.language]);
	const percentFormatter = useMemo(
		() => new Intl.NumberFormat(i18n.language, { style: "percent", minimumFractionDigits: 2, maximumFractionDigits: 2 }),
		[i18n.language],
	);
	const formatWhole = useCallback((value: number) => wholeFormatter.format(value), [wholeFormatter]);
	const formatPercent = useCallback((share: number) => percentFormatter.format(share), [percentFormatter]);
	return useMemo(() => ({ formatHours: formatWhole, formatCount: formatWhole, formatPercent }), [formatWhole, formatPercent]);
};
